import { trackSeoEvent } from './analytics';
export function captureEnquiryLandingPage() {
  try { if (!sessionStorage.getItem('ntp-landing-page')) sessionStorage.setItem('ntp-landing-page', window.location.pathname); } catch { /* Storage may be unavailable in private browsing. */ }
}
export async function submitEnquiry(data, submissionKey) {
  let landingPage = window.location.pathname;
  try { landingPage = sessionStorage.getItem('ntp-landing-page') || landingPage; } catch { /* Use current path. */ }
  const response = await fetch(`${import.meta.env.VITE_API_URL || '/api'}/enquiries`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': submissionKey },
    body: JSON.stringify({ ...data, landingPage }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || result.errors?.[0]?.msg || 'We could not save your inquiry. Please try again.');
  if (!result.duplicate) trackSeoEvent('generate_lead', { lead_type: data.leadSource, package_name: data.package || 'custom', inquiry_id: String(result.id) });
  return result;
}
